<template>
  <v-navigation-drawer
    app
    clipped
    right
    permanent
    class="pl-3 pr-2 pt-2"
    style="background-color: #eeeeee"
    :width="width"
  >
    <v-flex layout column align-center justify-center>
      <!-- paths settings-->
      <div style="width: 100%" v-if="parent === 'pathManagement'">
        <!-- <h4 class="font-weight-light">
          {{$t('settingsBar.pathManagement.title')}}
        </h4>
        <p class="subtitleClass">
          {{$t('settingsBar.pathManagement.subtitle')}}
        </p> -->

        <v-flex>
          <v-card>
            <!-- path params -->
            <v-card-actions>
              <v-btn
                color="primary"
                outline
                block
                class="text-none"
                @click="openPathSettings"
              >
                <v-icon color="primary">mdi-settings</v-icon>
                {{ $t('managePath.settings') }}
              </v-btn>
            </v-card-actions>
        
            <!-- carte missions -->
            <v-card-actions>
              <v-btn
                color="primary"
                outline
                block
                class="text-none"
                @click="openLocationDialog"
              >
                <v-icon color="primary">mdi-map</v-icon>
                {{ $t('managePath.showPathMap') }}
              </v-btn>
            </v-card-actions>

            <!-- stats -->
            <manageStats :pathId="pathId" />
          </v-card>
        </v-flex>

        <!-- checklist -->
        <v-card class="mt-2">
          <v-flex layout align-center justify-center>
            <span class="checklistTitle">{{
              $t('pathManagement.checklist.title')
            }}</span>
          </v-flex>
          <v-flex class="pa-2">
            <v-btn
              color="primary"
              outline
              block
              class="text-none"
              @click="$emit('openChecklist')"
            >
              <v-icon color="primary">mdi-format-list-checks</v-icon>
              {{ $t('pathManagement.checklist.open') }}
            </v-btn>
            <v-progress-linear
              color="primary"
              height="10"
              :placeholder="$t('pathManagement.placeholder.progression')"
              :value="checkListProgression"
              rounded
            ></v-progress-linear>
          </v-flex>
        </v-card>

        <!-- langues -->
        <v-card class="mt-2">
          <languageSelector
            :pathLanguages="pathInformations.langsEdited"
            :type="'path'"
            :pathId="pathId"
            :pathInfos="pathInfos"
            :accountInfos="accountInfos"
            :missionsInfos="missionsInfos"
            :checkListElements="checkListElements"
            :checkListPreviewMode="checkListPreviewMode"
            @change-lang-edition="changeLangEdition"
            @langs-path-to-translate="langsPathToTranslate"
            @delete-path-lang="deletePathLang"
          >
          </languageSelector>
        </v-card>

        <!-- delete path -->
        <v-flex>
          <v-btn
            class="text-none"
            color="red"
            outline
            block
            @click="openTextDialog('deletePath')"
          >
            <v-icon color="red">mdi-delete</v-icon>
            {{ $t('managePath.deletePath') }}
          </v-btn>
        </v-flex>

        <!-- errors -->
        <v-flex layout column align-center justify-center pt-0 mt-0>
          <span class="ruleTextClass" v-if="!isPathFormComplete">
            {{ $t('settingsBar.pathManagement.incomplete') }}
          </span>
          <span class="ruleTextClass" v-if="!areAllMissionsValid">
            {{ $t('settingsBar.pathManagement.draftMission') }}
          </span>
        </v-flex>

        <v-flex
          layout
          column
          align-center
          justify-center
          v-if="
            pathInformations.langsPublished &&
            !pathInformations.langsPublished.includes(langEdition)
          "
        >
          <!-- test dialog -->

          <v-btn
            color="primary"
            outline
            class="mt-4 text-none testButtonClassTwo"
            @click="openTestDialog()"
            :disabled="!isPathFormComplete || !areAllMissionsValid"
            >{{ $tc('settingsBar.pathManagement.test', $t(langEdition)) }}
          </v-btn>

          <!-- not published -->
          <!-- path expired -->
          <!-- v-btn
          v-if="isExpired"
          color="primary"
          class="mt-2 text-none testButtonClassTwo"
          @click="openPremiumDialog('publishedPathExpired')"
          :disabled="!isPathFormComplete || !areAllMissionsValid"
          >{{$t('settingsBar.pathManagement.publish')}}
          </v-btn-->
          <!-- path no promocode, limit of published path reached 
          <v-btn
          v-else-if="pathInformations.promoCode && pathInformations.promoCode.value===''"
          color="primary"
          class="mt-2 text-none testButtonClassTwo"
          @click="openPremiumDialog('publishedPathLimit')"
          :disabled="!isPathFormComplete || !areAllMissionsValid"
          >{{$t('settingsBar.pathManagement.publish' )}}
          </v-btn>-->

          <!-- path options dialog -->
        </v-flex>

        <!-- published -->
        <v-flex layout column align-center justify-center v-else>
          <!-- 2 buttons qr code & unpublish -->
          <v-flex layout row align-center justify-center>
            <v-btn
              large
              outline
              color="primary"
              class="text-none testButtonClassTwo"
              @click="openTestDialog()"
            >
              {{ $t('settingsBar.pathManagement.showQrcode') }}
            </v-btn>
          </v-flex>
          <v-flex layout row align-center justify-center>
            <v-btn
              color="red"
              outline
              @click="openTextDialog('unpublish')"
              class="text-none testButtonClassTwo"
            >
              {{ $t('settingsBar.pathManagement.unpublish') }}
            </v-btn>
          </v-flex>
          <!-- ask validation / validate path (if admin) -->
          <v-flex layout row align-center justify-center>
            <v-btn
              v-if="
                pathInformations.isPublished &&
                !isAdmin &&
                !pathInformations.isApproved
              "
              color="primary"
              class="text-none"
              @click="openTextDialog('askValidation')"
            >
              {{ $t('settingsBar.pathManagement.askValidation') }}
            </v-btn>
            <v-btn
              v-else-if="
                pathInformations.isPublished &&
                isAdmin &&
                !pathInformations.isApproved
              "
              color="primary"
              class="mt-2 text-none"
              @click="approvePath"
            >
              {{ $t('settingsBar.pathManagement.approvePath') }}
            </v-btn>
          </v-flex>
          <!-- info text path published / approved -->
          <v-flex column align-center justify-center>
            <v-icon color="green"> mdi-check </v-icon>
            {{ $t('settingsBar.pathManagement.published') }}
            <!-- </v-flex> -->
            <div
              v-if="pathInformations.isPublished && pathInformations.isApproved"
            >
              <v-icon color="green"> mdi-check </v-icon>
              {{ $t('settingsBar.pathManagement.pathApproved') }}
            </div>
          </v-flex>
        </v-flex>

        <v-flex layout column align-center justify-center>
          <!-- dates -->
          <span v-if="pathInformations.dateStart">
            <v-icon color="green"> mdi-calendar </v-icon>
            {{ dateStartLabel }}
          </span>
          <span v-if="pathInformations.dateEnd">
            <v-icon color="red"> mdi-calendar </v-icon>
            {{ dateEndLabel }}
          </span>

          <!-- credits -->
          <div v-if="isCreditValid">
            <v-icon color="green"> mdi-check </v-icon>
            {{ $t('credits.isValid') }}
          </div>
          <div v-else-if="!pathInformations.isPublished">
            <div>
              <v-icon v-if="hasCreditY" color="green"> mdi-check </v-icon>
              <v-icon v-else color="red"> mdi-close </v-icon>
              {{ $tc('credits.remaining.year', credits.year) }}
            </div>

            <div>
              <v-icon v-if="hasCreditD" color="green"> mdi-check </v-icon>
              <v-icon v-else color="red"> mdi-close </v-icon>
              {{ $tc('credits.remaining.day', credits.day) }}
            </div>
          </div>
          <v-btn
            v-if="!isCreditValid && !pathInformations.isPublished"
            @click="openCreditDialog"
            color="primary"
            class="text-none testButtonClassTwo"
          >
            {{ $tc('credits.buy') }}
          </v-btn>
        </v-flex>

        <!-- Publish button -->
        <v-flex layout column align-center justify-center>
          <v-btn
            v-if="
              pathInformations.langsPublished &&
              !pathInformations.langsPublished.includes(langEdition)
            "
            fixed
            bottom
            block
            color="primary"
            class="mt-2 pr-4 pl-4"
            @click="openPublishOptionsDialog"
            :disabled="!isPathFormComplete || !areAllMissionsValid"
            >{{ $t('settingsBar.pathManagement.publish') }}
          </v-btn>
        </v-flex>

        <!-- test dialog -->
        <v-dialog v-model="isTestDialogOpen" width="40%">
          <v-card>
            <v-flex layout align-center justify-center column pa-4>
              <v-card-title class="headline pt-0 mt-0"
              v-if="
                  pathInformations.langsPublished && 
                  pathInformations.langsPublished.includes(langEdition)
                "
                  >
                {{ $t('settingsBar.pathManagement.testPublishedTitle') }}</v-card-title
              >
              <v-card-title class="headline pt-0 mt-0"
                v-else
                  >
                {{ $t('settingsBar.pathManagement.testTitle') }}</v-card-title
              >
              <span
                v-if="
                  pathInformations.langsPublished &&
                  pathInformations.langsPublished.includes(langEdition)
                "
              >
                {{ $t('settingsBar.pathManagement.testPublished') }}</span
              >
              <span v-else> {{ $t('settingsBar.pathManagement.testScan') }}</span>
              <span v-if="locale !== langEdition">
                {{
                  $tc(
                    'settingsBar.pathManagement.testIn',
                    $t('languages.' + langEdition)
                  )
                }}
              </span>
              <img :src="getQrcodeUrl()" alt="qrcode" class="qrcode-image" />
              <span> {{ $t('settingsBar.pathManagement.testSameQRcode') }}</span>
            </v-flex>
          </v-card>
        </v-dialog>
      </div>

      <!-- missions settings -->
      <div v-if="parent === 'missionForm'">
        <h4 class="font-weight-light">
          {{ $t('settingsBar.missionForm.title') }}
        </h4>
        <p class="subtitleClass">
          {{ $t('settingsBar.missionForm.subtitle1') }}
          <br />
          {{ $t('settingsBar.missionForm.subtitle2') }}
        </p>
        <p class="subtitleClass">
          {{ $t('settingsBar.missionForm.subtitle3') }}
        </p>

        <v-card class="pt-2 pl-2 pr-2 pb-2">
          <v-flex layout align-center justify-center>
            <v-icon color="black">mdi-settings</v-icon>
            <span
              style="font-size: medium; padding-left: 5px"
              class="testClass"
              >{{ $t('settingsBar.missionForm.parameters') }}</span
            >
          </v-flex>

          <v-flex>
            <v-btn
              class="text-none mt-2"
              color="red"
              outline
              block
              @click="openTextDialog('deleteMission')"
            >
              <v-icon color="red">mdi-delete</v-icon>
              {{ $t('settingsBar.missionForm.delete') }}
            </v-btn>
          </v-flex>
        </v-card>

        <v-card class="mt-4 mb-4">
          <languageSelector
            :pathLanguages="pathInformations.langsEdited"
            :type="'mission'"
            :pathId="pathId"
            @change-lang-edition="changeLangEdition"
          >
          </languageSelector>
        </v-card>

        <v-btn
          v-if="!isNewMission"
          color="primary"
          class="text-none mt-4"
          block
          @click="goToPath()"
          >{{ $t('settingsBar.missionForm.return') }}
        </v-btn>

        <v-flex layout align-center justify-center pt-4>
          <p class="ruleTextClass" v-if="!isMissionFormValid">
            {{ $t('settingsBar.missionForm.invalidMission') }}
          </p>
        </v-flex>

        <v-flex
          layout
          column
          align-center
          justify-center
          pt-2
          v-if="invalidGamesForms.length > 0"
        >
          <p class="ruleTextClass">
            {{ $t('settingsBar.missionForm.invalidGames') }}
          </p>
          <p class="ruleTextClass">
            (

            <span
              v-for="(gameOrder, index) in invalidGamesForms"
              :value="gameOrder"
              :key="index"
            >
              <span v-if="index > 0"> / </span>
              {{ $tc('settingsBar.missionForm.game', gameOrder) }}
            </span>

            )
          </p>
        </v-flex>

        <v-flex
          layout
          column
          align-center
          justify-center
          pt-2
          v-if="invalidRewardsForms.length > 0"
        >
          <p class="ruleTextClass">
            {{ $t('settingsBar.missionForm.invalidRewards') }}
          </p>
          <p class="ruleTextClass">
            (

            <span
              v-for="(rewardOrder, index) in invalidRewardsForms"
              :value="rewardOrder"
              :key="index"
            >
              <span v-if="index > 0"> / </span>
              {{ $tc('settingsBar.missionForm.reward', rewardOrder + 1) }}
            </span>

            )
          </p>
        </v-flex>
      </div>

      <!-- stats settings -->
      <div v-if="parent === 'stats'">
        <v-flex pa-2>
          <h4 class="font-weight-light pb-4">
            {{ $t('settingsBar.statistics.title') }}
          </h4>
          <p class="subtitleClass">
            {{ $t('settingsBar.statistics.subtitle1') }}
          </p>
          <p class="subtitleClass">
            {{ $t('settingsBar.statistics.subtitle2') }}
          </p>

          <v-flex align-end justify-bottom pt-4>
            <v-btn color="primary" class="text-none" block @click="goToPath()"
              >{{ $t('settingsBar.missionForm.return') }}
            </v-btn>
          </v-flex>
        </v-flex>
      </div>
    </v-flex>

    <text-dialog
      v-if="typeTextDialog"
      :type="typeTextDialog"
      :isTextDialogOpen="isTextDialogOpen"
      :title="textDialogInformations[typeTextDialog].title"
      :details="textDialogInformations[typeTextDialog].details"
      :explanation="textDialogInformations[typeTextDialog].explanation"
      :cancelButtonText="textDialogInformations[typeTextDialog].cancel"
      :lottieUrl="textDialogInformations[typeTextDialog].lottieUrl"
      :confirmButtonText="textDialogInformations[typeTextDialog].confirm"
      :confirmButtonColor="
        textDialogInformations[typeTextDialog].confirmButtonColor
      "
      :pathInfos="pathInfos"
      :accountInfos="accountInfos"
      :missionsInfos="missionsInfos"
      :checkListElements="checkListElements"
      :checkListPreviewMode="checkListPreviewMode"
      @askValidation="askValidation"
      @publish-path="publishConfirmation"
      @unpublish-lang="unpublishLang"
      @cancel="cancelTextDialog"
      @cancel-checklist="cancelTextDialogChecklist"
      @delete-mission="deleteMission"
      @delete-path="deletePath"
      
    >
    </text-dialog>

    <premium-dialog
      v-if="isPremiumDialogOpen"
      :type="typeTextDialog"
      :isTextDialogOpen="isPremiumDialogOpen"
      :title="textDialogInformations[typeTextDialog].title"
      :explanation="textDialogInformations[typeTextDialog].explanation"
      :details="textDialogInformations[typeTextDialog].details"
      :cancelButtonText="textDialogInformations[typeTextDialog].cancel"
      :confirmButtonText="textDialogInformations[typeTextDialog].confirm"
      @confirm="closePremium()"
      @close-text-dialog="closePremium()"
      @cancel="closePremium()"
    >
    </premium-dialog>

    <!-- dialog missions map -->
    <v-dialog v-model="isLocationDialogOpen" width="100%" lazy>
      <v-card>
        <v-layout justify-center>
          <v-card-title class="headline">
            {{ $t('managePath.mapTitle') }}
          </v-card-title>
        </v-layout>
        <v-layout justify-center>
          <location-picker
            :defaultRadius="1000"
            :parent="'settingsBar'"
            :pathGeolocation="pathGeolocation"
            :missionsGeolocations="missionsPathGeolocations"
            :pathTrace="pathTrace"
            :isRealtime="isRealtime"
            :zoomOnClick="17"
            @cancel="closeLocationDialog"
            @switch-active="switchActiveMissions"
          />
        </v-layout>
      </v-card>
    </v-dialog>

    <credit-dialog
      v-if="isCreditDialogOpen"
      :typeTextDialog="typeTextDialog"
      :isTextDialogOpen="isCreditDialogOpen"
      :title="textDialogInformations[typeTextDialog].title"
      :explanation="textDialogInformations[typeTextDialog].explanation"
      :details="textDialogInformations[typeTextDialog].details"
      :cancelButtonText="textDialogInformations[typeTextDialog].cancel"
      :confirmButtonText="textDialogInformations[typeTextDialog].confirm"
      @confirm="closeCreditDialog()"
      @close-text-dialog="closeCreditDialog()"
      @cancel="closeCreditDialog()"
    >
    </credit-dialog>

    <publish-options-dialog
      v-if="isPublishOptionsDialogOpen"
      :pathInfos="pathInfos"
      :accountInfos="accountInfos"
      :missionsInfos="missionsInfos"
      :checkListElements="checkListElements"
      :isCreditValid="isCreditValid"
      @open-credit-dialog="openCreditDialog"
      @close="closePublishOptionsDialog"
    > 
    </publish-options-dialog>
  </v-navigation-drawer>
</template>

<script>
import UpcomingFeature from './UpcomingFeature';
//import ManagePath from './ManagePath';
import ManageStats from './ManageStats';
import TextDialog from './TextDialog';
import LanguageSelector from './LanguageSelector.vue';
import PremiumDialog from './PremiumDialog';
import CreditDialog from './CreditDialog.vue';
import PublishOptionsDialog from './PublishOptionsDialog.vue';
import LocationPicker from './LocationPicker.vue';
    

export default {
  name: 'settings-bar',
  components: {
    //UpcomingFeature,
    //ManagePath,
    ManageStats,
    TextDialog,
    PremiumDialog,
    CreditDialog,
    LanguageSelector,
    PublishOptionsDialog,
    LocationPicker,
  },
  props: {
    parent: {
      type: String,
      default: null,
    },
    pathId: {
      type: String,
      default: null,
    },
    width: {
      type: String,
      default: '300',
    },
    isMissionFormValid: {
      type: Boolean,
      default: true,
    },
    invalidGamesForms: {
      type: Array,
      default: null,
    },
    invalidRewardsForms: {
      type: Array,
      default: null,
    },
    isNewMission: {
      type: Boolean,
      default: false,
    },
    areAllMissionsValid: {
      type: Boolean,
      default: false,
    },
    areDraftMissions: {
      type: Array,
      default: null,
    },
    isPathFormComplete: {
      type: Boolean,
      default: true,
    },
    checkListProgression: {
      type: Number,
      default: 0,
    },
    pathInfos: {
      type: Object,
      default: null,
    },
    missionsInfos: {
      type: Object,
      default: null,
    },
    accountInfos: {
      type: Object,
      default: null,
    },
    checkListElements: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      //minMissionsNumber: 3,
      isTextDialogOpen: false,
      isTestDialogOpen: false,
      isTested: false,
      isPremiumDialogOpen: false,
      isCreditDialogOpen: false,
      isPublishOptionsDialogOpen: false,
      typeTextDialog: '',
      langEdition: null,
      checkListPreviewMode: true,
      useFreeCredit: false,
      mapPlayers: true,
      isLocationDialogOpen: false,
      lottieConfetti:
        'https://assets6.lottiefiles.com/packages/lf20_rovf9gzu.json',
    };
  },
  computed: {
    isAdmin() {
      if (this.currentUser && this.currentUser.isAdmin) {
        return this.currentUser.isAdmin;
      }
      return false;
    },
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    userPublishedPaths() {
      return Object.values(this.$store.state.paths.paths).filter(
        (path) => path.isPublished === true
      );
    },
    currentAccount() {
      return this.$store.getters['accounts/currentAccount'];
    },
    locale() {
      return this.$i18n.locale;
    },
    pathInformations() {
      if (this.pathId) {
        return this.$store.getters['paths/getPathById'](this.pathId);
      }
      return false;
    },
    pathTrace() {
      let trace=null;
      if (this.pathInformations.trace) {
        trace = {latlngs: this.pathInformations.trace.coordinates};
      }
      if (this.pathInformations.traceProperties) {
        trace.properties = this.pathInformations.traceProperties
      }
      return trace
    },
    pathGeolocation() {
      return this.pathInformations.geolocation;
    },
    isRealtime() {
      return this.pathInformations.isRealtime;
    },
    missionsPathGeolocations() {
      let missionsPathGeolocations = [];
      this.pathInformations.missions.forEach((mission) => {
        const missionContent = this.$store.getters['missions/getMissionById'](
          mission.missionId
        );
        const activeExist = typeof mission.isActive !== 'undefined';
        const isActive = activeExist ? mission.isActive : true;
        if (missionContent && mission.geolocationInPath) {
          let missionName = missionContent.name.fr;
          missionsPathGeolocations = [
            ...missionsPathGeolocations,
            {
              missionId: mission.missionId,
              name: missionName,
              isActive: isActive,
              missionGeolocation: mission.geolocationInPath,
            },
          ];
        }
      });
      return missionsPathGeolocations;
    },
    credits() {
      return this.currentAccount.credits || { year: 0, day: 0 };
    },
    hasCreditD() {
      return this.credits.day > 0;
    },
    hasCreditY() {
      return this.credits.year > 0;
    },
    hasCredit() {
      return this.hasCreditD || this.hasCreditY;
    },
    hasPromoCode() {
      return (
        this.pathInformations.promoCode &&
        this.pathInformations.promoCode.value !== ''
      );
    },
    isCreditValid() {
      return (
        this.allowedDates(this.pathInformations.dateEnd) &&
        (this.hasPromoCode ||
          !this.allowedDates(this.pathInformations.dateStart))
      );
    },
    //pathLimit() {
    //  return this.currentAccount.pathLimit ;
    //},
    //isMaxPublishedPath() {
    //  return Object.keys(this.userPublishedPaths).length >= this.pathLimit;
    //},
    //isExpired () {
    //  return this.pathInformations.dateEnd && parseInt(this.pathInformations.dateEnd) < Date.now();
    //},
    dateStartLabel() {
      return new Date(this.pathInformations.dateStart).toLocaleString(
        this.locale,
        {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }
      );
    },
    dateEndLabel() {
      return new Date(this.pathInformations.dateEnd).toLocaleString(
        this.locale,
        {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }
      );
    },
    textDialogInformations() {
      return {
        askValidation: {
          title: this.$t(
            'settingsBar.textDialogInformations.askValidation.title'
          ),
          explanation: this.$t(
            'settingsBar.textDialogInformations.askValidation.explanation'
          ),
          details: this.$t(
            'settingsBar.textDialogInformations.askValidation.details'
          ),
          confirm: this.$t(
            'settingsBar.textDialogInformations.askValidation.confirm'
          ),
          cancel: this.$t(
            'settingsBar.textDialogInformations.askValidation.cancel'
          ),
          confirmButtonColor: 'primary',
        },
        publishIncompleteChecklist: {
          title: this.$t(
            'settingsBar.textDialogInformations.publishIncompleteChecklist.title'
          ),
          explanation: this.$t(
            'settingsBar.textDialogInformations.publishIncompleteChecklist.explanation'
          ),
          details: this.$t(
            'settingsBar.textDialogInformations.publishIncompleteChecklist.details'
          ),
          confirm: this.$t(
            'settingsBar.textDialogInformations.publishIncompleteChecklist.confirm'
          ),
          cancel: this.$t(
            'settingsBar.textDialogInformations.publishIncompleteChecklist.cancel'
          ),
          confirmButtonColor: 'primary',
        },
        published: {
          title: this.$t('settingsBar.textDialogInformations.published.title'),
          explanation: this.$t(
            'settingsBar.textDialogInformations.published.explanation',
            { date: this.dateEndLabel }
          ),
          details: this.$t(
            'settingsBar.textDialogInformations.published.details'
          ),
          confirm: this.$t(
            'settingsBar.textDialogInformations.published.confirm'
          ),
          cancel: this.$t(
            'settingsBar.textDialogInformations.published.cancel'
          ),
          lottieUrl: 'images/congrats.json',
        },
        publish: {
          title: this.$t('settingsBar.textDialogInformations.publish.title'),
          explanation: this.$t(
            'settingsBar.textDialogInformations.publish.explanation'
          ),
          details: this.$t(
            'settingsBar.textDialogInformations.publish.details'
          ),
          cancel: this.$t('settingsBar.textDialogInformations.publish.cancel'),
          confirm: this.$t(
            'settingsBar.textDialogInformations.publish.confirm'
          ),
          confirmButtonColor: 'primary',
        },
        unpublish: {
          title: this.$tc(
            'settingsBar.textDialogInformations.unpublish.title',
            this.$t('languages.' + this.langEdition)
          ),
          explanation: this.$tc(
            'settingsBar.textDialogInformations.unpublish.explanation',
            this.$t('languages.' + this.langEdition)
          ),
          details:
            this.pathInformations.langsPublished &&
            this.pathInformations.langsPublished.length === 1
              ? this.$t('settingsBar.textDialogInformations.unpublish.details')
              : null,
          cancel: this.$t(
            'settingsBar.textDialogInformations.unpublish.cancel'
          ),
          confirm: this.$t(
            'settingsBar.textDialogInformations.unpublish.confirm'
          ),
          confirmButtonColor: 'primary',
        },
        
        
        //publishedPathLimit: {
        //  title: this.$t('premiumDialog.title.publishedPathLimit'),
        //  explanation: this.$t('settingsBar.textDialogInformations.publishedPathLimit.explanation'),
        //  confirm: this.$t('settingsBar.textDialogInformations.publishedPathLimit.confirm'),
        //  confirmButtonColor: 'primary'
        //},
        publishedPathExpired: {
          title: this.$t(
            'settingsBar.textDialogInformations.pathExpired.title'
          ),
          explanation: this.$t(
            'settingsBar.textDialogInformations.pathExpired.explanation'
          ),
          details: ' ',
          confirm: this.$t(
            'settingsBar.textDialogInformations.pathExpired.confirm'
          ),
          confirmButtonColor: 'primary',
        },
        buyCredit: {
          title: this.$t('credits.dialog.title'),
          explanation: this.$t('credits.dialog.explanation'),
          details: this.$t('credits.dialog.details'),
          confirm: this.$t('credits.dialog.confirmButtonText'),
          cancel: this.$t('credits.dialog.cancelButtonText'),
          confirmButtonColor: 'primary',
        },
        deleteMission: {
          title: this.$t(
            'settingsBar.textDialogInformations.deleteMission.title'
          ),
          explanation: this.$t(
            'settingsBar.textDialogInformations.deleteMission.explanation'
          ),
          cancel: this.$t(
            'settingsBar.textDialogInformations.deleteMission.cancel'
          ),
          confirm: this.$t(
            'settingsBar.textDialogInformations.deleteMission.confirm'
          ),
          confirmButtonColor: 'red',
        },
        deletePath: {
          title: this.$t('settingsBar.textDialogInformations.deletePath.title'),
          explanation: this.$t(
            'settingsBar.textDialogInformations.deletePath.explanation'
          ),
          cancel: this.$t(
            'settingsBar.textDialogInformations.deletePath.cancelButtonText'
          ),
          confirm: this.$t(
            'settingsBar.textDialogInformations.deletePath.confirmButtonText'
          ),
          confirmButtonColor: 'red',
        },
      };
    },
  },
  created() {
    this.langEdition = this.locale;
    if (this.pathInformations.isMapAvailable) {
        this.mapPlayers = this.pathInformations.isMapAvailable;
      }
  },
  methods: {
    openTextDialog(type) {
      this.typeTextDialog = type;
      this.isTextDialogOpen = true;
      if (type === 'publishIncompleteChecklist') {
        this.checkListPreviewMode = false;
      }
    },
    openTestDialog() {
      this.isTestDialogOpen = true;
      this.isTested = true;
    },
    openPathSettings() {
      this.$router.push(`/pathSettings/${this.pathId}`)
    },
    cancelTextDialog() {
      this.typeTextDialog = '';
      this.isTextDialogOpen = false;
    },
    cancelTextDialogChecklist() {
      this.isTextDialogOpen = false;
    },
    approvePath() {
      this.$emit('approve-path');
    },
    openPremiumDialog(type) {
      this.typeTextDialog = type;
      this.isPremiumDialogOpen = true;
    },
    openPublishOptionsDialog() {
      console.log('open publish options');
      this.isPublishOptionsDialogOpen = true;
    },
    closePublishOptionsDialog(type) {
      console.log('closePublishOptions t:', type);
      this.isPublishOptionsDialogOpen = false;
      this.useFreeCredit = false;
      this.typeTextDialog = '';
      if (type === 'publish') {
        this.openTextDialog('published');
        this.$emit('add-lang-published', this.langEdition);
      }
      // this.openTextDialog('publish')
    },
    closePremium() {
      this.typeTextDialog = null;
      this.isPremiumDialogOpen = false;
      this.isTextDialogOpen = false;
    },
    //closeTextDialog() {
    //  this.isTextDialogOpen=false;
    //},
    openCreditDialog() {
      this.typeTextDialog = 'buyCredit';
      this.isCreditDialogOpen = true;
    },
    closeCreditDialog() {
      this.isCreditDialogOpen = false;
      this.typeTextDialog = null;
      this.isTextDialogOpen = false;
    },
    openLocationDialog() {
      this.isLocationDialogOpen = true;
    },
    closeLocationDialog() {
      this.isLocationDialogOpen = false;
    },
    goToPath() {
      this.$emit('go-to-path');
    },
    createAndAddMission() {
      this.$emit('create-mission');
    },
    goBackWithoutSave() {
      this.$emit('dont-update-mission');
    },
    deleteMission() {
      this.typeTextDialog = '';
      this.isTextDialogOpen = false;
      this.$emit('delete-mission');
    },
    changeLangEdition(newLangEdition) {
      this.langEdition = newLangEdition;
      this.$emit('change-lang-edition', newLangEdition);
    },
    langsPathToTranslate(langs) {
      this.$emit('langs-path-to-translate', langs);
    },
    deletePathLang(lang) {
      this.$emit('delete-path-lang', lang);
    },
    async deletePath() {
      await this.$store.commit('app/SET_LOADING');
      this.$router.push('/homePage');
      try {
        await this.$store.dispatch('paths/DELETE_PATH', {
          pathId: this.pathId,
          index: this.$store.getters['auth/currentUserIndex'],
          kuzzle: this.$kuzzle,
        });
      } catch (error) {
        console.error(error.message);
      }
      await this.$store.commit('app/UNSET_LOADING');
    },
    async publishConfirmation() {
      this.typeTextDialog = '';
      this.isTextDialogOpen = false;
      this.openTextDialog('published');
      this.$emit('add-lang-published', this.langEdition);
    },
    unpublishLang() {
      this.typeTextDialog = '';
      this.isTextDialogOpen = false;
      this.$emit('unpublish-lang', this.langEdition);
    },
    getQrcodeUrl() {
      if (this.pathId) {
        return this.pathId.length
          ? `https://api.qrserver.com/v1/create-qr-code/?size=450x450&data=https://explorama.app/play/${this.pathId}`
          : '';
      }
      return;
    },
    async askValidation() {
      console.log('send validation request');
      const request = {
        controller: 'tracking',
        action: 'askValidation',
        body: {
          email: this.currentUser.username,
          account: this.currentAccount.name.fr,
          path: this.pathInformations,
        },
      };
      try {
        await this.$kuzzle.query(request);
        this.isTextDialogOpen = false;
        // this.openConfirmDialog = true;
      } catch (error) {
        console.error(error);
      }
    },
    allowedDates(val) {
      const yesterday = new Date().setDate(new Date().getDate() - 1);
      return new Date(val) > yesterday;
    },
    switchActiveMissions(activeMissionsList) {
      const pathMissions = this.pathInformations.missions.map((m) => {
        const mg = this.missionsPathGeolocations.find(
          (mg) => mg.missionId === m.missionId
        );
        const mm = JSON.parse(JSON.stringify(m));
        if (activeMissionsList.includes(mg.name)) {
          mm.isActive = true;
        } else {
          mm.isActive = false;
        }
        return mm;
      });
      let payload = { missions: pathMissions };
      this.$emit('update-path',payload);
    },
  },
  watch: {
    async mapPlayers(newValue, oldValue) {
      if (oldValue === null || newValue === this.pathInformations.isMapAvailable) {
        return;
      }
      const payload = { isMapAvailable: newValue };
      this.$emit('update-path',payload);
      //await this.updatePath(payload);
    },
  },
};
</script>

<style lang="sass" scoped>

.subtitleClass
  font-size: small;
  text-align: justify;
  text-justify: inter-word;
  line-height: 120%
  color: grey
  margin-bottom: 8px;

.checklistTitle
  padding-top: 8px;
.ruleTextClass
  color: red
  font-size: small;
  text-align: justify;
  text-justify: center;
  line-height: 120%;
  margin-bottom: 2px;

.qrcode-image
  margin-top: 15px;
  width: 250px;

.testButtonClassTwo
  height: 28px;
</style>
